// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__VpJW0","head":"ProcedureTableInfo_head__322bb"};